export default {

  contactDetails: ((state, getters, rootState) => (translatorId, bucket = 'entities') => {
    if (!rootState[bucket].translators[translatorId]) {
      return [];
    }
    return (rootState[bucket].translators[translatorId].contactDetails || []).map(id => rootState.entities.contactDetails[id])
  }),

  contactLanguages: ((state, getters, rootState) => (contactId, bucket = 'entities') => {
    if (!rootState[bucket].contacts[contactId]) {
      return [];
    }
    return (rootState[bucket].contacts[contactId].languages || []).map(id => rootState.entities.languages[id])
  }),

  contacts: ((state, getters, rootState) => (translatorId, bucket = 'entities') => {
    if (!rootState[bucket].translators[translatorId]) {
      return [];
    }
    return (rootState[bucket].translators[translatorId].contacts || []).map(id => rootState.entities.contacts[id])
  }),

  contactContactDetails: ((state, getters, rootState) => (contactId, bucket = 'entities') => {
    if (!rootState[bucket].contacts[contactId]) {
      return [];
    }
    return (rootState[bucket].contacts[contactId].contactDetails || []).map(id => rootState.entities.contactDetails[id])
  }),

  addTranslatorDialog: (state) => { return state.addTranslatorDialog },
  translatorEditDialog: (state) => { return state.translatorEditDialog },

  activeTranslatorsIds: (state) => { return state.activeTranslatorsIds }
};



// WEBPACK FOOTER //
// ./src/store/translators/getters.js